import {gql} from "@apollo/client";

export const EVENT_DETAIL_PUBLIC = gql`
query GetEventDetail($eventId: ID!) {
  eventDetail(eventId: $eventId) {
    id
        title
        description
        date
        status
        eventType
        address
        latitude
        longitude
        createdBy{
            id
        }
        season{
            name
            division{
                name
                organization{
                    name
                }
            }
        }
        field{
            id
            name
            sportFacility{
                latitude
                longitude
                address
            }
        }
        responsibles
        managers
        game{
            id
            homeTeam{
                id
                name
                logo
                players{
                    id
                    playerId
                    fullName
                    shirtNumber
                    status
                    position{
                        key
                        name
                    }
                    sanction{
                        type
                        gamesSuspended
                    }
                }
                role
            }
            visitorTeam{
                id
                name
                logo
                players{
                    id
                    playerId
                    fullName
                    shirtNumber
                    status
                    position{
                        key
                        name
                    }
                    sanction{
                        type
                        gamesSuspended
                    }
                }
                role
            }
            forfeitTeam{
                id
                name
                logo
            }
            scoreHome
            scoreVisitor
            resultType
            penaltiesHome
            penaltiesVisitor
            group{
                id
                name
            }
            matchDay
            gameAlias
            homeAway
            noPlay
        }
        trainingSession{
            id
            participants{
                id
                fullName
            }
        }
        competition{
            id
            participants{
                id
                fullName
            }
        }
        genericEvent{
            id
            participants{
                id
                fullName
            }
            address
            latitude
            longitude
        }
        attendances{
            profile{                
                id
                fullName                
            }
            confirmation
            attendance
        }
        invites{
            email
        }
        publicPhotos{
            id
            imageUrl
            thumbnailUrl
            caption
            createdAt
        }
  }
}
`;
